import { getAnalyticsActor, posthog } from './posthog'

/**
 * Thu ngân kết thúc popup "Đặt hàng thành công!" ở POS bằng cách nào (M-184):
 *   - `print`: bấm "In hóa đơn thanh toán" và mở được lệnh in (popup tự đóng).
 *   - `print_failed`: bấm In nhưng không mở được lệnh in (popup giữ lại).
 *   - `close_button`: bấm nút chữ "Đóng".
 *   - `dismiss`: đóng bằng dấu X, phím Esc hoặc bấm ra ngoài.
 *
 * `print` chỉ nghĩa hộp thoại in của browser / tab PDF đã mở, chưa chứng minh
 * máy in đã nhả giấy. KHÔNG gửi mã đơn, số tiền hay tên khách: chỉ enum.
 * Analytics lỗi hoặc tắt không được chặn việc in / đóng popup.
 */
export type PosOrderSuccessAction =
    'print' | 'print_failed' | 'close_button' | 'dismiss'

export function capturePosOrderSuccessAction(input: {
    action: PosOrderSuccessAction
    paymentMethod: 'cash' | 'bank_transfer'
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('pos_order_success_action', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            action: input.action,
            payment_method: input.paymentMethod,
        })
    } catch {
        // Analytics không được chặn việc in / đóng popup.
    }
}
